<template>
  <div class="trans-feed-selector">
    <div class="accounts">
      <div class="title">账号</div>
      <div
        class="account-item"
        :class="{ active: index === activeAccountIndex }"
        @click="onAccountChange(index)"
        v-for="(item, index) in accounts"
        :key="index"
      >
        <span>{{ item.name }}</span>
        <span v-if="value[item.id]" style="color:red;">[已选]</span>
        <i v-if="index === activeAccountIndex" class="el-icon-arrow-right"></i>
      </div>
    </div>

    <div class="trans-list">
      <div class="title">转化名称</div>
      <div class="search-box">
        <el-input v-model="searchStr" clearable placeholder="输入关键词搜索"></el-input>
      </div>
      <div class="list-wrapper">
        <div
          class="trans-item"
          :class="{ active: item.appTransId === currAppTransId }"
          @click="onResultSelect(item.appTransId)"
          v-for="item in nameItems"
          :key="item.appTransId"
        >
          <span class="item-text">
            <span>
              {{ item.transName }}
              &ensp;<span v-html="getTransText(item)"></span> &ensp; <span v-html="getDeepTransTypes(item)"></span>
            </span>
            <i v-if="item.appTransId === currAppTransId" class="el-icon-circle-check"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const transTypes = {
  49: '登录',
  26: '付费',
  4: '激活'
}
const deepTransTypes = {
  26: '付费'
}
export default {
  props: {
    accounts: {
      type: Array
    },
    transList: {
      type: Array
    },
    value: {
      type: Object
    }
  },
  computed: {
    currAccountId() {
      return this.accounts[this.activeAccountIndex].id
    },
    currAppTransId() {
      const { appTransId } = this.value[this.currAccountId] || {}
      return appTransId
    },
    nameItems() {
      if (!this.searchStr) return this.transList
      return this.transList.filter((i) => i.transName.toLowerCase().includes(this.searchStr.toLowerCase()))
    }
  },

  data() {
    return {
      searchStr: '',
      activeAccountIndex: 0,
      activeTransIndex: ''
    }
  },
  methods: {
    getTransText(item) {
      const [id] = item.transTypes || []
      const txt = transTypes[id]
      return txt ? `转化目标：${transTypes[id]}` : ''
    },
    getDeepTransTypes(item) {
      const [id] = item.deepTransTypes || []
      const txt = deepTransTypes[id]
      return txt ? `深度目标：${deepTransTypes[id]}` : ''
    },
    onAccountChange(index) {
      this.activeAccountIndex = index
      const { id } = this.accounts[index] || {}
      id && this.$emit('account-change', id)
      this.searchStr = ''
    },
    onResultSelect(appTransId) {
      const newValue = {
        ...this.value
      }

      const accountId = this.accounts[this.activeAccountIndex].id
      const transObj = this.transList.find((i) => i.appTransId === appTransId)
      newValue[accountId] = transObj

      this.$emit('input', newValue)
    }
  }
}
</script>
<style lang="scss" scoped>
.trans-feed-selector {
  border: 1px solid #dcdee2;
  border-radius: 4px;
  display: flex;
  min-height: 200px;

  .title {
    background: #ebebeb;
    padding: 5px 10px;
    font-size: 14px;
  }
  .search-box {
    padding: 5px 10px;
  }
  .accounts {
    font-size: 12px;
    border-right: 1px solid #dcdee2;
    flex-basis:  260px;
    .account-item {
      cursor: pointer;
      padding: 5px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.active {
        color: #1974ff;
      }
    }
  }

  .trans-list {
    font-size: 12px;
    flex: 1;
    .list-wrapper {
      max-height: 120px;
      overflow: auto;
      .trans-item {
        padding: 5px 10px;
        cursor: pointer;
        &.active {
          background: #f3f3f3;
        }
        .item-text {
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
